import classNames from "classnames";
import React from "react";

export default function Tabs({
  tabs,
  selectedTab,
  onChange,
  className,
}: {
  tabs: string[];
  selectedTab: string;
  onChange: (tab: string) => void;
  className?: string;
}) {
  return (
    <div className={className}>
      <nav
        aria-label="Tabs"
        className="flex space-x-4"
      >
        {tabs.map((tab) => (
          <button
            key={tab}
            className={classNames(
              tab === selectedTab
                ? "bg-gray-100 text-gray-700"
                : "text-gray-500 hover:text-gray-700",
              "rounded-md px-3 py-2 text-sm font-medium capitalize"
            )}
            onClick={() => {
              onChange(tab);
            }}
          >
            {tab}
          </button>
        ))}
      </nav>
    </div>
  );
}
